import addDomainNamedValuesToAttributes from "./addDomainNamedValuesToAttributes";
import injectDates from "./injectDates";

export default function addGeometryAndNamedValuesState(features, domains) {
  if (!features || features.length < 1) return [];
  // get date keys using regex to extract the iso form
  const keys = Object.keys(features[0].attributes);
  const dateKeys = keys.filter((item) => item.match(/date/gi));
  if (!domains)
    return features.map((feature) => ({
      ...feature.attributes,
      ...injectDates(feature, dateKeys),
      geometry: feature.geometry,
    }));
  return features
    .map((feature) => ({
      ...feature.attributes,
      ...injectDates(feature, dateKeys),
      geometry: feature.geometry,
    }))
    .map((item) => {
      const domainFieldsAsName = addDomainNamedValuesToAttributes(
        domains,
        item
      );
      return { ...item, ...domainFieldsAsName };
    });
}
